interface Props {
  goal: string;
}

export function TimelineGoalSticky({ goal }: Props) {
  return (
    <div className="sticky top-12 md:top-0 z-10 mb-6 rounded-md border border-border border-l-2 border-l-primary bg-muted px-4 py-3 backdrop-blur supports-[backdrop-filter]:bg-muted/95">
      <div className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
        Ziel
      </div>
      <p className="mt-1 text-sm whitespace-pre-line">{goal}</p>
    </div>
  );
}
